module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-合作与发展banner.1432a1dc.png";